/*#__PURE__*/ enum LOG_LEVEL {
  LOG = 1,
  WARN = 2,
  ERROR = 3,
  INFO = 4,
  DEFAULT = 5,
}

/*#__PURE__*/ enum CONNECTIONS {
  AEM_CONNECTION_NAME = 'OWC_AEM_ENV',
  REGISTRY_CONNECTION_NAME = 'OWC_COMPONENT_REGISTRY',
  TRACKING_CONNECTION_NAME = 'OWC_TRACKING_MANAGER',
  AUTH_CONNECTION_NAME = 'B2XCORE_AUTHENTICATION',
  PROFILE_CONNECTION_NAME = 'B2XCORE_PROFILE',
}

/*#__PURE__*/ enum STAGES {
  LOCAL = 'local',
  DEVELOP = 'dev',
  TEST = 'test',
  INT = 'int',
  PPROD = 'pprod',
  PROD = 'prod',
}

/*#__PURE__*/ enum TENANT {
  ONEWEB = 'oneweb',
  OFLOGIN = 'OFLOGIN',
  CIAS = 'cias',
  MARKETPLACE_CORE = 'mrkplc-core',
}

export { LOG_LEVEL, CONNECTIONS, STAGES, TENANT };
